import 'react-app-polyfill/stable';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import i18next from 'i18next';
import './i18n';
import './tailwind.generated.css';
import './index.css';
import App from './App';
import EmployeeSignIn from './EmployeeSignIn';
import QRCodePage from './pages/terminal/QRCodePage';
import TerminalMainPage from './pages/terminal/TerminalMainPage';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Submitted } from './pages/Submitted';
import { Rejected } from './pages/Rejected';
import { Response } from './pages/Response';
import { Temp } from './pages/terminal/Temp';
import { FinishWithoutScanTemperature } from './pages/terminal/FinishWithoutScanTemperature';
import { ResponseWithoutScanTemperature } from './pages/ResponseWithoutScanTemperature';
import { VisitorQueue } from './pages/VisitorQueue';
import { MyBooking } from './pages/mybooking/MyBooking';
import { CancelBooking } from './pages/mybooking/CancelBooking';
import { SignOut } from './pages/mybooking/SignOut';
import { InvitationStatus } from './pages/mybooking/InvitationStatus';
import { EventsQueue } from './pages/EventsQueue';
import { EmergencyMessaging } from './pages/EmergencyMessaging';
import { RollCallSummary } from './pages/RollCallSummary';
import { CrisisTeam } from './pages/crisisteam';
import { EventsCalendar } from './pages/EventsCalendar';
import { EventResponse } from './pages/EventResponse';
import ThirdPartyCompliance from './pages/ThirdPartyCompliance';
import 'react-phone-number-input/style.css';
import RegisterGuestResponse from './pages/RegisterGuestResponse';
import EventNoEmailFound from './pages/EventNoEmailFound';

const parsedQueryString = queryString.parse(window.location.search);
const lng = parsedQueryString.language || 'en';
const siteId = parsedQueryString.siteId || '';
i18next.changeLanguage(lng);

const url = new URLSearchParams(window.location.search);
const isTerminal = url.get('source') === 'terminal';
const redirectType = isTerminal ? 'terminal' : '';

sessionStorage.setItem('siteOptions', JSON.stringify({ siteId: siteId, lng: lng }));
sessionStorage.setItem('isTerminal', JSON.stringify({ isTerminal: isTerminal }));
sessionStorage.setItem('redirectType', JSON.stringify({ redirectType: redirectType }));

const Loader = () => <div className="Loader">loading...</div>;
const preloader = document.querySelector('.preloadercontainer');

// if you want to show the loader when React loads data again
const showLoader = () => preloader.classList.remove('preloadercontainer--hide');

const hideLoader = () => preloader.remove();

function Index(props) {
  useEffect(() => {
    console.log('window.location.href =>', window.location.pathname);
    const path = window.location.pathname;
    const favicon = document.getElementById('favicon');
    if (path === '/mybooking') {
      favicon.href = '/my_lobby_logo_version_2_black.png';
    } else {
      favicon.href = '/favicon.ico';
    }
  }, []);

  return isTerminal ? (
    <React.Suspense fallback={<Loader />}>
      <Router>
        <Switch>
          <Route path="/temperature">
            <Temp showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/withouttemperature">
            <FinishWithoutScanTemperature showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/submitted">
            <Submitted showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/response">
            <Response showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/event-response">
            <EventResponse showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/register-guest-response">
            <RegisterGuestResponse showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/event-no-email-found">
            <EventNoEmailFound showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/responsewithouttemperature">
            <ResponseWithoutScanTemperature showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/rejected">
            <Rejected showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/qrcode">
            <QRCodePage showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/visitorqueue">
            <VisitorQueue showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/">
            <TerminalMainPage showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
        </Switch>
      </Router>
    </React.Suspense>
  ) : (
    <React.Suspense fallback={<Loader />}>
      <Router>
        <Switch>
          <Route path="/submitted">
            <Submitted showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/withouttemperature">
            <FinishWithoutScanTemperature showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/rejected">
            <Rejected showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/response">
            <Response showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/event-response">
            <EventResponse showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/register-guest-response">
            <RegisterGuestResponse showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/event-no-email-found">
            <EventNoEmailFound showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/responsewithouttemperature">
            <ResponseWithoutScanTemperature showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/employee/:employeeId">
            <EmployeeSignIn showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/visitorqueue">
            <VisitorQueue showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/mybooking">
            <MyBooking showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/cancelbooking/:bookingId">
            <CancelBooking showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/signout">
            <SignOut showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/invitationStatus">
            <InvitationStatus showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/eventsqueue">
            <EventsQueue showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/eventscalendar">
            <EventsCalendar showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/ThirdPartyComplaince">
            <ThirdPartyCompliance showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/emergencyMessaging">
            <EmergencyMessaging showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/crisisTeam">
            <CrisisTeam showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/rollcallsummary">
            <RollCallSummary showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
          <Route path="/">
            <App showLoader={showLoader} hideLoader={hideLoader} />
          </Route>
        </Switch>
      </Router>
    </React.Suspense>
  );
}

ReactDOM.render(<Index hideLoader={hideLoader} showLoader={showLoader} />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
